ProfilValidator.$inject = ['validator'];

export default function ProfilValidator(validator) {
    const instance = new validator();

    instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('libelle').length(1, 100).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');

    instance.ruleFor('niveauxAccesDomaines').length(1).withMessage('VALIDATION_TOO_SHORT_SELECTION');

    return instance;
}
